import { memo, forwardRef } from 'react';
import TabList from './tabList.factory.js';
import Tabs from '../tabs/tabs.js';
var _tablistPropsManager = function tablistPropsManager(ins, ref, state) {
  var openTabIDs = state.openTabIDs,
    selectedTabID = state.selectedTabID;
  return {
    openTabIDs: openTabIDs,
    selectedTabID: selectedTabID,
    ref: ref,
    dir: ins.getOption('direction'),
    isVertical: ins.getOption('isVertical')
  };
};
export { _tablistPropsManager as tablistPropsManager };
var MemomizedTabList = /*#__PURE__*/memo( /*#__PURE__*/forwardRef(TabList.bind(undefined, function (ins) {
  return {
    Tabs: Tabs,
    tablistPropsManager: function tablistPropsManager(ref, state) {
      return _tablistPropsManager(ins, ref, state);
    }
  };
})), function () {
  return true;
});
export default MemomizedTabList;